
let appVersion = '0.1.0';

export default {
    apiUrl:   'https://cp.treasurehuntheroes.com/api/v1/',
    siteUrl:  'https://cp.treasurehuntheroes.com',
    appVersion: appVersion,
    frontendTimeoutUpdate: 500,
    status: {
        NEW:     0,
        ACTIVE:  1,
        FINISH:  2,
        PAUSE:   3,
        TIMEOUT: 8,
        ARCHIVE: 9,
        CANCEL:  10,
    },
    statusName: {
        0: 'New',
        1: 'In game',
        2: 'Finished',
        3: 'Pause',
        8: 'Stopped',
        9: 'Archive',
        10: 'Cancel',
    },
}